import SubmissionError from '../../../../../error/SubmissionError'
import fetch from '../../../../../utils/fetch'
import * as types from './mutation_types'

export const reset = ({ commit }) => {
  commit(types.THUMBNAIL_CREATE_RESET)
}

export const create = ({ commit, state, dispatch }, { gameId, type, thumbnail }) => {
  commit(types.THUMBNAIL_CREATE_RESET)
  commit(types.THUMBNAIL_CREATE_SET_LOADING, true)

  const formData = new FormData()
  formData.append('game', gameId)
  formData.append('type', type)
  formData.append('image', thumbnail)

  return fetch('thumbnails', { method: 'POST', body: formData })
    .then((response) => response.json())
    .then((data) => {
      commit(types.THUMBNAIL_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      if (e instanceof SubmissionError) {
        commit(types.THUMBNAIL_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.THUMBNAIL_CREATE_SET_ERROR, e.errors._error)
        return
      }

      commit(types.THUMBNAIL_CREATE_SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.THUMBNAIL_CREATE_SET_LOADING, false)
    })
}
